import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { filterContinents } from 'shared/functions';
import { fetchEntitiesCountries } from 'services';
import { getParsedRegions } from 'selectors/common';

export const useRegions = searchQuery => {
  const allRegions = useSelector(getParsedRegions);
  const [regions, setRegions] = useState(allRegions);

  useEffect(() => {
    const fetchCountries = async () => {
      if (!allRegions.isPending && searchQuery) {
        const entitiesCountries = await fetchEntitiesCountries({ query: searchQuery });
        const filteredRegions = allRegions.data.filter(region =>
          filterContinents(region, entitiesCountries),
        );

        setRegions({ ...allRegions, data: filteredRegions });
        return;
      }

      setRegions(allRegions);
    };

    fetchCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allRegions]);

  return regions;
};
